/**
 * A clinician's display name. Accepting an invitation only asks for a
 * password, so new clinicians have no first/last name on file — show their
 * email instead.
 */
export function clinicianName(p: { firstName?: string | null; lastName?: string | null; email?: string | null }): string {
  const full = `${p.firstName ?? ""} ${p.lastName ?? ""}`.trim();
  return full || p.email || "Clinician";
}

/** Two-letter avatar initials: from the name when there is one, else the email's first letter. */
export function clinicianInitials(p: { firstName?: string | null; lastName?: string | null; email?: string | null }): string {
  const fromName = `${(p.firstName ?? "").charAt(0)}${(p.lastName ?? "").charAt(0)}`;
  return (fromName || (p.email ?? "").charAt(0) || "P").toUpperCase();
}
